<template>
  <div>
    <AddFormItem
      :bp="bp"
      :fields="fields"
      :custom_icon="custom_icon"
      @submit="submit_action"
    />
  </div>
</template>

<script>
  import AddFormItem from '@/components/bpcreator/model/AddFormItem';
  export default {
    components: {
      AddFormItem
    },
      
    name: 'AddFilter',
      
    props: {
      bp: {default: () => ({})},
      field: {default: () => ({})},
      custom_icon: {default: 'mdi-plus'},
      roles: {default: ()=>({})},
    },
        
    data: () => ({
    }),
      
    computed: {
      fields() {
        let res = [];
        for (let item of (this.bp.new_filter_property().props || [])) {
          res.push([
            {
              ...item,
              'cols': 4,
              'items': item && item.items_funct ? (item.items_funct)(this.bp) : [],
              'value': item && item.value_funct ? (item.value_funct)(this.field,this.bp.lang) : (this.field || {})[item.id],
            }
          ])
        }
        return res;
      }
    },

    methods: {
      submit_action(values) {
        let items = {...this.field,...values};
        this.$emit('submit',items);
      },
    },
  }
</script>